import { RichTextContent } from 'contentful';
import { ComponentModel } from '~contentful/models/components/component.model';

export class RichTextModel {

    constructor (
        public readonly obj: RichTextContent,
        public readonly target?: ComponentModel,
        public readonly content: RichTextModel[] = [],
    ) {
    }
}
